"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaultBalance = getVaultBalance;
exports.getAlphaVaultBalance = getAlphaVaultBalance;
exports.getSingleAssetVaultBalance = getSingleAssetVaultBalance;
exports.getDoubleAssetVaultBalance = getDoubleAssetVaultBalance;
exports.getAllVaultBalances = getAllVaultBalances;
const fetchUserVaultBalances_js_1 = require("./sui-sdk/functions/fetchUserVaultBalances.js");
const fetchLiquidityChangeEvents_js_1 = require("./sui-sdk/events/fetchLiquidityChangeEvents.js");
const parseData_js_1 = require("./sui-sdk/events/parseData.js");
const userHoldings_js_1 = require("./utils/userHoldings.js");
const prices_js_1 = require("./utils/prices.js");
const maps_js_1 = require("./common/maps.js");
const index_js_1 = require("./index.js");
// TODO: review the multiGet mode
async function getVaultBalance(address, poolName, multiGet) {
    if (address && poolName && !multiGet) {
        const vaultBalance = await (0, fetchUserVaultBalances_js_1.fetchUserVaultBalances)(address, poolName, false);
        return vaultBalance;
    }
    else if (!address && !poolName && multiGet) {
        // multirun
        const liquidityChangeEvents = await (0, fetchLiquidityChangeEvents_js_1.fetchLiquidityChangeEvents)(multiGet);
        const xTokenHoldingsArr = (0, parseData_js_1.parseXTokensFromLCEvent)(liquidityChangeEvents);
        const xTokenHoldingsObj = xTokenHoldingsArr.map(([address, poolName, xTokens]) => {
            return {
                owner: address,
                poolName: poolName,
                holding: xTokens,
            };
        });
        const liquidityHoldingsObj = await (0, userHoldings_js_1.multiXTokensToLiquidity)(xTokenHoldingsObj);
        const tokenHoldingsObj = await (0, userHoldings_js_1.multiLiquidityToTokens)(liquidityHoldingsObj);
        const usdHoldingsObj = await (0, userHoldings_js_1.multiTokensToUsd)(tokenHoldingsObj);
        const uniqueUsdHoldings = {};
        usdHoldingsObj.map((usdHolding) => {
            uniqueUsdHoldings[`${usdHolding.owner}_${usdHolding.poolName}`] =
                usdHolding.holding;
        });
        const multiVaultBalances = tokenHoldingsObj.map((tokenHolding) => {
            const owner = tokenHolding.user;
            const poolName = tokenHolding.poolName;
            const tokensInUsd = uniqueUsdHoldings[`${owner}_${poolName}`];
            if ("tokens" in tokenHolding) {
                return {
                    owner: owner,
                    poolName: poolName,
                    tokens: tokenHolding.tokens,
                    tokensInUsd: tokensInUsd,
                };
            }
            else {
                return {
                    owner: owner,
                    poolName: poolName,
                    tokenA: tokenHolding.tokenAmountA,
                    tokenB: tokenHolding.tokenAmountB,
                    tokensInUsd: tokensInUsd,
                };
            }
        });
        return multiVaultBalances;
    }
    else {
        throw new Error("Invalid Params: Give only multiGet or only address and poolName");
    }
}
async function getAlphaVaultBalance(address) {
    const vaultBalance = await getVaultBalance(address, "ALPHA");
    return vaultBalance;
}
async function getSingleAssetVaultBalance(address, poolName) {
    const vaultBalance = await getVaultBalance(address, poolName);
    return vaultBalance;
}
async function getDoubleAssetVaultBalance(address, poolName) {
    const vaultBalance = await getVaultBalance(address, poolName);
    return vaultBalance;
}
async function getAllVaultBalances(address) {
    await Promise.all([
        (0, prices_js_1.getMultiLatestPrices)(),
        (0, index_js_1.getMultiCetusPool)(),
        (0, index_js_1.getMultiInvestor)(),
        (0, index_js_1.getMultiParentPool)(),
        (0, index_js_1.getMultiReceipts)(address),
        (0, index_js_1.getMultiPool)(),
    ]);
    const pools = Object.keys(maps_js_1.poolInfo);
    const res = new Map();
    const promises = pools.map(async (pool) => {
        const result = await getVaultBalance(address, pool);
        res.set(pool, result);
    });
    await Promise.all(promises);
    return res;
}
//# sourceMappingURL=getVaultBalances.js.map